export default __webpack_public_path__ + "static/media/Emmanuel Miegwei.dd3aa44d.jpg";